<template>
  <div class="send">
    <!-- 弹层内容 -->
    <div class="addWrap">
      <div class="subTitBox">修改物流</div>
      <!-- conTent -->
      <div class="addConWrap">
        <!-- 选择 -->
        <ul class="colList selectList">
          <li>
            <span class="col-tit">物流公司</span>
            <el-select v-model="result.express_type" placeholder="请选择物流" class="selectLog">
              <el-option
                      v-for="item in expressCompanies"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code">
              </el-option>
            </el-select>
            <el-input v-model="result.express_num" placeholder="请输入快递单号" class="logistics"></el-input>
          </li>
        </ul>
        <!-- 底部按键 -->
        <div class="botBtn">
          <button @click="handleCancel" class="butStyle whiteBtn cancelBtn">取消</button>
          <button @click="handleConfirm" class="butStyle pinkBtn enterBtn">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getLogisticsReq} from "@/api/Order/NumCardOrder/internetBuyCardOrder.js";

  export default {
    name: "updateLogistics",
    props: {
      orderItem: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        result: {
          express_type: undefined,
          express_num: undefined,
          needLogistics: '1',
          id: this.orderItem.id
        },
        checked: false,
        expressCompanies: []
      }
    },
    created() {
      this.result.express_num = this.orderItem.express_num
      this.result.express_type = this.orderItem.express_type
      this.initExpressCompanies()
    },
    methods: {
      handleCancel() {
        this.$emit('cancel')
      },
      // 确定事件
      handleConfirm() {
        // 把result对象传递上去
        this.$emit('confirm', this.result)
      },
      handleChange(val) {
        this.result.needLogistics = val
      },
      initExpressCompanies() {
        getLogisticsReq()
            .then(resp => {
              this.expressCompanies = resp.body.expresses
            })
            .catch(e => console.log(e))
      }
    },
  }
</script>

<style scoped>
  .send {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background:rgba(0,0,0,0.6);
  }

  .send .addWrap {
    position: absolute;
    width: 640px;
    top: 50%;
    left: 50%;
    border: 1px solid #eee;
    /* -webkit-box-shadow: 6px 6px 12px #ccc;
    -moz-box-shadow: 6px 6px 12px #ccc;
    box-shadow: 6px 6px 12px #ccc; */
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 33;
  }

  .addConWrap {
    padding: 14px 14px 24px;
  }

  /* 列表标题 */
  .listTit {
    height: 28px;
    line-height: 28px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    background: #7F7F7F;
  }

  .listTit li {
    width: 100px;
    font-weight: bold;
  }

  .listTit li:nth-child(1) {
    width: 34px;
  }

  .listTit li:nth-child(2) {
    width: 220px;
    text-align: left;
  }

  .listTit li:nth-child(5) {
    width: 156px;
    text-align: left;
    text-indent: 30px;
  }

  .goodLi {
    background: #fff;
    margin-top: 0;
    height: 60px;
    color: #3B3B3B;
    border-bottom: 1px solid #eee;
  }

  .goodLi li {
    display: flex;
    height: 100%;
    text-align: center;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .goodLi li:nth-child(2) {
    justify-content: flex-start;
  }

  .goodLi li:nth-child(2) img {
    width: 44px;
    height: 44px;
  }

  .goodLi li:nth-child(2) .titDetail {
    width: 180px;
    margin-left: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* autoprefixer: off */
    /* autoprefixer: off */
    -webkit-box-orient: vertical; /* autoprefixer: on */
    /* autoprefixer: on */
    font-size: 12px;
    line-height: 17px;
    margin-top: -9px;
    font-weight: normal;
  }

  .goodLi li:nth-child(5) {
    justify-content: flex-start;
    font-size: 12px;
  }

  .goodLi li.listTime > span {
    width: 66px;
    color: #B7B2AF;
  }

  /* 选择 */
  .selectList {
    margin-top: 20px;
  }

  .selectLog {
    width: 128px;
    margin-right: 10px;
  }

  .logistics {
    width: 240px;
  }

  /* 底部按键 */
  .botBtn {
    margin-top: 36px;
  }

  .botBtn .enterBtn {
    margin-left: 14px;
  }
</style>
